import { DAMAGE_OSD_TYPE } from "../constants";

export const supportsSpecialInstructions = (osdType?: string): boolean => {
  const normalizedType = osdType?.trim().toUpperCase();
  return DAMAGE_OSD_TYPE.includes(normalizedType as any);
};

export const getAccountCustomerCode = (
  accountValue?: string | number | null,
): string | undefined => {
  if (accountValue === null || accountValue === undefined) {
    return undefined;
  }

  const normalized = accountValue.toString().trim();
  return normalized || undefined;
};
